module.exports = __webpack_public_path__ + "img/gettedticket.4d732ead.png";